const formatCurrency = (number, symbol = 'R') => {
  return symbol + number.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

const formatNumbers = (number) => {
  return number.toLocaleString();
};

export const useStringFormatter = () => {
  return {
    formatCurrency,
    formatNumbers,
  };
};
